import { render, staticRenderFns } from "./sticker.vue?vue&type=template&id=398041bb&scoped=true&"
import script from "./sticker.vue?vue&type=script&lang=ts&"
export * from "./sticker.vue?vue&type=script&lang=ts&"
import style0 from "./sticker.vue?vue&type=style&index=0&id=398041bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398041bb",
  null
  
)

export default component.exports